import environment from "@/environment";

export enum GTM_EVENT {
	BUSINESS_EMAIL_CLICK = 'emailBusinessClick',
	BUSINESS_EMAILED = 'businessEmailed',
	BUSINESS_TEXT_CLICK = 'textBusinessClick',
	BUSINESS_TEXTED = 'businessTexted',
	BUSINESS_PHONE_CLICK = 'businessPhoneClick',
	CONTACT_FORM_SUBMITTED = 'contact_form_submitted',
	NEWSLETTER_FORM_SUBMITTED = 'newsletter_form_submitted',
	DIALOG_OPENED = 'dialog_opened',
	DOWNLOAD = 'file_download',
	FORM_INVALID = 'form_invalid',
	FORM_FIELD_VALIDATION_ERROR = 'field_validation_error',
	SEARCH = 'search',
}

export function useGtm() {
	const dataLayer = window.dataLayer || [];

	function setDialog(dialogId: string) {
		pushEvent(GTM_EVENT.DIALOG_OPENED, { dialogId });
	}

	function pushEvent(event: GTM_EVENT|string, data?: Record<string, any>) {
		if (Object.values(GTM_EVENT).includes(event as GTM_EVENT) !== true) {
			throw Error(`Invalid GTM event: ${event}`);
		}

		if (environment.env === 'production') {
			dataLayer.push({
				event, ...data
			});

			console.log('GTM Event:', event, data);
		}

	}

	function pushFieldValidationErrors(formName: string, errors: Record<string, string[]>) {
		Object.keys(errors).forEach(fieldName => {
			pushEvent(GTM_EVENT.FORM_FIELD_VALIDATION_ERROR, {
				formName,
				fieldName,
				fieldError: errors[fieldName][0]
			});
		});
	}

	return {
		pushEvent,
		setDialog,
		pushFieldValidationErrors
	}
}
